var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-text-editor',{ref:"textEditor",staticClass:"mt-4",attrs:{"error-text":_vm.$t('sTextEditor.contentRequired')}})}
var staticRenderFns = []

export { render, staticRenderFns }